export enum TodoResponsibility {
  /**
   * @description 本職
   */
  OWN = 'own',
  /**
   * @description 代理
   */
  SUB = 'sub',
}
